import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
var a = /*#__PURE__*/function () {
  function a() {
    _classCallCheck(this, a);

    this.name = this.constructor.name || "UnnamedBrush";
  }

  _createClass(a, [{
    key: "prepareState",
    value: function prepareState(_a, r, t) {}
  }, {
    key: "draw",
    value: function draw(_a2, r, t) {}
  }, {
    key: "drawMany",
    value: function drawMany(_a3, r, t) {
      var _iterator = _createForOfIteratorHelper(r),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var s = _step.value;
          this.draw(_a3, s, t);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }]);

  return a;
}();

export { a as default };